/* eslint-disable */
//tslint:disable

export interface IHouseOfferHistoryDesktopSchema {
  /** Дата снятия объекта **/
  dateEnd?: string | null;
  /** Дата публикации **/
  dateStart: string;
  /** Тип сделки **/
  dealType: EDealType;
  /** Строка цены по оценке Циан **/
  estimatedPrice: string;
  /** Строка цены за квадрат по оценке Циан **/
  estimatedPriceSqm?: string | null;
  /** Строка срока показа объявления **/
  exposition: string;
  /** Идентификатор объявления **/
  id: number;
  /** Относительная ссылка на оффер **/
  link?: string | null;
  /** Фото объявления **/
  previewPhoto?: string | null;
  /** Изменилась ли цена при снятии по сравнению с ценой при подаче **/
  priceDiff: EPriceDiff;
  /** Строка цены в рублях на момент снятия объявления **/
  priceEnd: string;
  /** Строка цены в рублях за квадратный метр на момент снятия объявления **/
  priceEndSqm?: string | null;
  /** Строка цены в рублях объекта на момент подачи объявления **/
  priceStart: string;
  /** Строка цены в рублях за квадратный метр на момент подачи **/
  priceStartSqm?: string | null;
  /** Текстовый заголовок для квартиры, включающий площадь, комнатность и этаж **/
  title: string;
}

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}
export enum EPriceDiff {
  /** Цена уменьшилась **/
  Decrease = 'decrease',
  /** Цена увеличилась **/
  Increase = 'increase',
  /** Цена не изменилась **/
  NoChange = 'noChange',
}
